export const iconFontAwesomeArrowsAnglesRight = (
	<i className="fa-solid fa-angles-right"></i>
);
